export const SET_STATIC_DATA = "SET_STATIC_DATA";
export const SET_ERROR_DATA = "SET_ERROR_DATA";
